<template>
  <div v-if="!$apollo.loading">
    <div class="container mt-10">
      <header class="h2 font-bold">
        <div class="text-secondary">
          Categorie
        </div>
        <div>
          <span v-for="(category, index) in activiteit.categories" :key="category.name">
            {{ category.name }}{{ index !== activiteit.categories.length - 1 ? ', ' : '' }}
          </span>
        </div>
      </header>
    </div>
    <content-wave>
      <main class="w-full flex flex-wrap">
        <section class="w-full lg:w-2/3">
          <header class="h2 font-bold mb-8">
            <div class="text-secondary">
              Titel
            </div>
            <div>
              {{ activiteit.title }}
            </div>
          </header>

          <main class="main-content lg:pb-6">
            <div v-if="activiteit.beschrijving" class="content prose" v-html="activiteit.beschrijving"/>
            <a v-if="activiteit.aanmeld_url" :href="activiteit.aanmeld_url" target="_blank" rel="noopener nofollow" class="btn btn-secondary">
              Aanmelden voor activiteit
            </a>
          </main>
        </section>

        <section class="w-full lg:w-1/3 pt-12 lg:pl-4">
          <img v-for="image in activiteit.images" :key="image.url" :src="image.url" class="image w-full object-cover mb-3">
        </section>
      </main>
    </content-wave>

    <transition name="fade">
      <template v-if="openModal">
        <subscribe-to-event @event:close-modal="toggleModal"/>
      </template>
    </transition>
  </div>
</template>

<script>
import contentWave from '~/components/fullwidth-blocks/WaveshapeEmpty';
import SubscribeToEvent from '~/components/modals/SubscribeToEvent';
import activiteit from '~/graphql/queries/activiteit';

export default {
  components: {SubscribeToEvent, contentWave},
  apollo: {
    activiteit: {
      query: activiteit,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data: () => ({
    openModal: false,
    activiteit: {},
  }),
  methods: {
    toggleModal() {
      this.openModal = !this.openModal;
    },
  },
  head() {
    const title = this.activiteit.seo?.meta_title ? this.activiteit.seo.meta_title : this.activiteit.title;

    return {
      title,
      meta: [
        this.activiteit.seo?.meta_description
          ? {
            hid: 'description',
            name: 'description',
            content: this.activiteit.seo.meta_description,
          }
          : {},
        this.activiteit.seo?.meta_index !== undefined
          ? {
            hid: 'robots',
            name: 'robots',
            content: (this.activiteit.seo.meta_follow ? 'follow ' : 'nofollow ') + (this.activiteit.seo.meta_index ? 'index' : 'noindex'),
          }
          : {},
        {
          hid: 'og:title',
          name: 'og:title',
          content: title,
        },
        this.activiteit.seo?.meta_description
          ? {
            hid: 'og:description',
            name: 'og:description',
            content: this.activiteit.seo.meta_description,
          }
          : {},
        this.activiteit.active_image
          ? {
            hid: 'og:image',
            name: 'og:image',
            content: this.activiteit.active_image.url,
          }
          : {},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.h3 {
  @apply mb-3;
}

.image {
  height: 300px;
  @screen xl {
    height: 450px;
  }
}

.main-content {
  column-count: 1;
  @screen lg {
    column-count: 2;
    column-gap: 2rem;
  }
}
</style>
